module.exports = __webpack_public_path__ + "static/ipad-24d481a2659ce3a43aa9d398bdcfeaed.png";